var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWritingFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.646,
    height: 36.25,
    viewBox: "0 0 34.646 36.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "writing-file",
    transform: "translate(0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49848",
    "data-name": "Path 49848",
    d: "M1.372,5.161A.221.221,0,0,1,1.16,4.98L.008.28A.217.217,0,0,1,.159.008.215.215,0,0,1,.432.189l1.152,4.7a.215.215,0,0,1-.182.273Z",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 7.451, 1.639)",
    fill: "#ff6562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49849",
    "data-name": "Path 49849",
    d: "M31.869,44.806H10.92A3.708,3.708,0,0,1,7.1,41.187V14.419A3.708,3.708,0,0,1,10.92,10.8H35.689V41.187A3.708,3.708,0,0,1,31.869,44.806Z",
    transform: "translate(-6.888 -9.019)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49850",
    "data-name": "Path 49850",
    d: "M37.4,48.065H18.21a1.847,1.847,0,0,1-1.91-1.793V20.793A1.847,1.847,0,0,1,18.21,19H39.28V46.271A1.839,1.839,0,0,1,37.4,48.065Z",
    transform: "translate(-13.299 -14.733)",
    fill: "none",
    stroke: "#06617A ",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49851",
    "data-name": "Path 49851",
    d: "M82.586,26.089,74.4,18.57l8.155-7.67Z",
    transform: "translate(-55.113 -9.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49852",
    "data-name": "Path 49852",
    d: "M23.295,10.577a1.214,1.214,0,0,1-1.152-.788l-1.819-5A2.056,2.056,0,0,1,20.657,2.6a1.723,1.723,0,0,1,1.667-.515,2.052,2.052,0,0,1,1.425,1.637A.265.265,0,0,1,23.567,4a.217.217,0,0,1-.273-.152,1.644,1.644,0,0,0-1.091-1.3,1.2,1.2,0,0,0-1.213.364,1.645,1.645,0,0,0-.212,1.728l1.819,5a.793.793,0,0,0,.97.455.624.624,0,0,0,.455-.758L22.961,5.393a.738.738,0,0,0-.3-.424.606.606,0,0,0-.394-.061.447.447,0,0,0-.3.273.615.615,0,0,0-.03.515l.97,2.759a.24.24,0,1,1-.455.152l-.97-2.759a1.106,1.106,0,0,1,.061-.879.91.91,0,0,1,.576-.485,1.109,1.109,0,0,1,.758.091,1.149,1.149,0,0,1,.546.7l1.061,3.941a1.085,1.085,0,0,1-.758,1.3A2.827,2.827,0,0,1,23.295,10.577Z",
    transform: "translate(-16.001 -2.04)",
    fill: "#ff6562"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49853",
    "data-name": "Path 49853",
    d: "M78.533,55.189a2.226,2.226,0,0,1,2.183-.273,3.443,3.443,0,0,1,1.849,1.728,2.6,2.6,0,0,1-.364,2.486c-1.3,1.364-8.549,9.277-10.823,10.156A54.215,54.215,0,0,1,65.8,71.106c.182-.546,1.213-2.607,1.728-4.123a5.406,5.406,0,0,1,1.334-2.122C69.529,64.194,78.442,55.189,78.533,55.189Z",
    transform: "translate(-49.596 -40.969)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49854",
    "data-name": "Path 49854",
    d: "M109.376,59.54h0l-.546.546a.821.821,0,0,1-1.152-.091l-2.607-2.7a.783.783,0,0,1-.091-1c.394-.394.637-.606.637-.606a2.226,2.226,0,0,1,2.183-.273,3.672,3.672,0,0,1,1.849,1.728A2.569,2.569,0,0,1,109.376,59.54Z",
    transform: "translate(-76.801 -40.87)",
    fill: "#b3b8bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49855",
    "data-name": "Path 49855",
    d: "M109.9,59.616h0l-.606.576a.723.723,0,0,1-.333.182l.121-.121h0a2.836,2.836,0,0,0,.3-2.516,3.563,3.563,0,0,0-1.91-1.849,2.351,2.351,0,0,0-1.971.061,3.075,3.075,0,0,1,.455-.424,2.385,2.385,0,0,1,2.3-.3,3.727,3.727,0,0,1,1.94,1.849A2.9,2.9,0,0,1,109.9,59.616Z",
    transform: "translate(-77.261 -40.738)",
    fill: "#b3b8bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49856",
    "data-name": "Path 49856",
    d: "M67.9,103.248l-2.4.7.819-1.88C66.8,101.126,68.138,102.187,67.9,103.248Z",
    transform: "translate(-48.54 -73.917)",
    fill: "#b3b8bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49857",
    "data-name": "Path 49857",
    d: "M38.669,64.5l-11.157-.182h0a.228.228,0,1,0,.03.455Zm-11.126-5L41.61,58.83l-14.1.212h0a.234.234,0,0,0-.212.243A.216.216,0,0,0,27.543,59.5Zm.182-6.73L41.761,52.1l-14.067.212h0a.234.234,0,0,0-.212.243A.216.216,0,0,0,27.724,52.767Zm28.68.788-.121-.121a.227.227,0,1,0-.273.364,2.186,2.186,0,0,1,.91,1.486,6.478,6.478,0,0,1-.121,1.88,5.893,5.893,0,0,0,.364-1.88A2.674,2.674,0,0,0,56.4,53.555ZM51.432,55.89a72.23,72.23,0,0,0-7.882,8A76.4,76.4,0,0,0,51.432,55.89Zm-7.67,10.762A76.8,76.8,0,0,0,51.948,58.5,115.489,115.489,0,0,0,43.762,66.652Z",
    transform: "translate(-22.768 -38.955)",
    fill: "#06617A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49858",
    "data-name": "Path 49858",
    d: "M36.709,22.79A2.591,2.591,0,0,0,34.7,23.853h0l-.748.747V10.23a.227.227,0,0,0-.23-.23H10.225A3.847,3.847,0,0,0,6.4,13.851V40.638a3.822,3.822,0,0,0,3.825,3.823H30.1a3.84,3.84,0,0,0,3.825-3.823V32.677c1.955-1.954,5.2-5.375,5.262-5.461a2.628,2.628,0,0,0,.288-2.472A3.258,3.258,0,0,0,36.709,22.79Zm-3.192,1.38L26.27,17.53l7.218-6.783Zm0,16.5a3.4,3.4,0,0,1-3.393,3.392h-19.9a3.4,3.4,0,0,1-3.393-3.392V13.88a3.423,3.423,0,0,1,3.393-3.42H33.172L25.81,17.387c-.058.029-.058.086-.058.144a.158.158,0,0,0,.086.144l7.707,7.042V25C23.452,35.063,26.1,31.93,23.711,37.218c-.518,1.15-.546,1.207-.46,1.322h0l-10.438-.172h0a.216.216,0,1,0,.029.431L23.28,38.54h0l.029.029c.086.086.086.086,2.444-.632h0c3.422-1.063,3.825-1.092,7.764-4.944v7.674ZM25.235,36.9a1.306,1.306,0,0,1,.259.747l-1.7.489c.23-.517.546-1.293.575-1.351A.647.647,0,0,1,25.235,36.9Zm-.575-.747A21.724,21.724,0,0,1,25.7,33.712a3.174,3.174,0,0,0,2.358,3.075h0c-.748.287-1.438.517-2.1.719C25.868,36.672,25.034,36.011,24.66,36.155Zm3.738.517a4.246,4.246,0,0,1-2.617-3.1,5.046,5.046,0,0,1,.69-.862l8.08-8.076a.747.747,0,0,0,.259.46c2.444,2.443,2.473,2.788,3.077,2.9C36.22,29.745,30.5,35.867,28.4,36.672Zm10.467-9.743c-1.237,1.035-.489,1.15-3.738-2.127a.567.567,0,0,1-.086-.661c.029-.029.518-.489.575-.546a1.565,1.565,0,0,1,1.121-.374A2.859,2.859,0,0,1,39.1,24.888,2.9,2.9,0,0,1,38.866,26.929Z",
    transform: "translate(-6.4 -8.461)",
    fill: "#06617A",
    stroke: "#06617A",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingFile);
export default __webpack_public_path__ + "static/media/writing-file.4f08f9bb47b9108947c1824e9dd93b48.svg";
export { ForwardRef as ReactComponent };